import { entityType } from 'config/entityType';
import { getPermissionByEntityType } from 'library/helpers/getPrimary';
import SuperFetch from 'library/helpers/superFetch';
import { useManagePermittedRoles } from 'library/hooks';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { floorsActions } from 'reduxStore/floors/slice';
import { organisationActions } from 'reduxStore/organisations/slice';
import { peopleActions } from 'reduxStore/people/slice';
import { sitesActions } from 'reduxStore/sites/slice';
import { teamsActions } from 'reduxStore/teams/slice';
import { Notification } from 'zComponents/atoms';
import { Button, Modal, Typography } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';

const { Text } = Typography;

const DeleteContactModal = ({ children, data = {}, type }) => {
	// Hooks
	const dispatch = useDispatch();
	const { permissionName, rules } = getPermissionByEntityType(type, data);
	const isPermittedUpdate = useManagePermittedRoles(permissionName, rules);

	// Local State
	const [visible, setVisible] = useState(false);
	const [loading, setLoading] = useState(false);

	const dispatchActions = () => {
		switch (type) {
			case entityType.WORKSPACE:
				dispatch(organisationActions.loadOrganisations());
				break;
			case entityType.SITE:
				dispatch(sitesActions.loadSites());
				break;
			case entityType.FLOOR:
				dispatch(sitesActions.loadSites());
				dispatch(floorsActions.loadFloors());
				break;
			case entityType.TEAM:
				dispatch(teamsActions.loadTeams());
				break;
			case entityType.PERSON:
				dispatch(peopleActions.loadPerson());
				break;
			default:
				break;
		}
	};

	const handleDelete = async () => {
		const formData = {};

		switch (type) {
			case entityType.WORKSPACE:
				formData.orgID = data.orgID;
				break;
			case entityType.SITE:
				formData.siteID = data.siteID;
				break;
			case entityType.FLOOR:
				formData.floorID = data.floorID;
				break;
			case entityType.TEAM:
				formData.teamID = data.teamID;
				break;
			case entityType.PERSON:
				formData.personID = data.personID;
				break;
			default:
				break;
		}

		try {
			setLoading(true);
			const res = await SuperFetch.delete(`/contact`, {
				...formData,
				contactTypeID: data.contactTypeID
			});
			if (res.statusCode === 200) {
				dispatchActions();
				handleCancel();
				Notification('success', 'Contact Deleted Successful.');
			} else if (res.error.statusCode === 400) {
				handleCancel();
				Notification('error', 'Please fill out all required information with proper type.');
			}
		} catch (err) {
			setLoading(false);
			Notification('error', 'There is an Error! We are mending the problem, try again soon!.');
		}
	};

	const handleCancel = () => {
		setVisible(false);
		setLoading(false);
	};

	return (
		<Fragment>
			<ConditionalTooltipButton
				buttonText={'Delete'}
				condition={!isPermittedUpdate}
				disabledCondition={!isPermittedUpdate}
				trueTitle={"You don't have permission"}
				falseTitle={'Delete Contact'}
				onClick={() => {
					setVisible(true);
				}}
				danger={true}
			>
				{children}
			</ConditionalTooltipButton>
			<Modal
				title={`Delete Contact`}
				danger
				open={visible}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={[
					<Button key='cancel' onClick={() => handleCancel()}>
						Cancel
					</Button>,
					<Button loading={loading} key='delete' danger onClick={() => handleDelete()}>
						Delete
					</Button>
				]}
			>
				<Text style={{ textAlign: 'center' }}>Are you sure you want to permanently delete the contact?</Text>
			</Modal>
		</Fragment>
	);
};

export default DeleteContactModal;
